import React from 'react'
import { css } from '@emotion/core'
import { Link } from 'gatsby'
import MenuItem from './MenuItem'
import CoreMenu from './CoreMenu'

const DesktopMenu = ({ data }) => <div
  css={theme => css`
    ${theme.breakpoints.sm('display: none;')}
  `}
>
  <ul
    css={theme => css`
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    @media (max-width: 1200px){
      li:nth-last-child(-n+2) {
        display: none
      }
    };
    ${theme.breakpoints.md('.menu-category-item { display: none }')}
  `}
  >
    <CoreMenu />
    {
      data.allWordpressCategory.edges.map(({ node }) => {
        return (
          <MenuItem
            slug={`/blog/${node.slug}`}
            text={node.name}
            className="menu-category-item"
          />
        )
      })
    }
  </ul>
</div>

export default DesktopMenu